import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import * as Sentry from '@sentry/react';
import { MDSTheme } from '@marqvision/mds/core';
import theme from '@marqvision/shared/src/library/theme';
import { ErrorBoundaryView } from '~/pages/ErrorPage/ErrorBoundary';
import LoadingCircularProgress from './components/Common/LoadingCircularProgress';
import LayoutWrapper from './components/Common/Layouts/LayoutWrapper';
import './App.css';
import { useSentryUserInfoUpdate } from './hooks/useSentryUserInfoUpdate';
import { ThemeProvider as MDSThemeProvider } from '@emotion/react';
import { MDSThemeValue, MDSResetCSS } from '@marqvision/mds-v2';

const LoginPage = lazy(() => import('./pages/LoginPage'));
const Dashboard = lazy(() => import('./pages'));
const AuthOkta = lazy(() => import('./components/User/AuthOkta'));
const AuthOktaCallback = lazy(() => import('./components/User/AuthOktaCallback'));

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    backgroundColor: MDSTheme.palette.bluegray[850],
  },
}));

const App = () => {
  const classes = useStyles();
  useSentryUserInfoUpdate();

  return (
    <Sentry.ErrorBoundary fallback={<ErrorBoundaryView />} showDialog>
      <MuiThemeProvider theme={{...theme, ...MDSThemeValue}}>
        <Router>
          <div className={classes.root}>
            <LayoutWrapper>
              <CssBaseline />
              <MDSThemeProvider theme={MDSThemeValue}>
                <MDSResetCSS />
                <Routes>
                  <Route
                    path="/"
                    element={
                      <Suspense fallback={<LoadingCircularProgress open />}>
                        <LoginPage />
                      </Suspense>
                    }
                  />
                  <Route
                    path="/login"
                    element={
                      <Suspense fallback={<LoadingCircularProgress open />}>
                        <LoginPage />
                      </Suspense>
                    }
                  />
                  <Route
                    path="/auth/okta"
                    element={
                      <Suspense fallback={<LoadingCircularProgress open />}>
                        <AuthOkta />
                      </Suspense>
                    }
                  />
                  <Route
                    path="/auth/okta-callback"
                    element={
                      <Suspense fallback={<LoadingCircularProgress open />}>
                        <AuthOktaCallback />
                      </Suspense>
                    }
                  />
                  <Route
                    path="/*"
                    element={
                      <Suspense fallback={<LoadingCircularProgress open />}>
                        <Dashboard />
                      </Suspense>
                    }
                  />
                </Routes>
              </MDSThemeProvider>
            </LayoutWrapper>
          </div>
        </Router>
      </MuiThemeProvider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
